import { render, staticRenderFns } from "./InvoiceReceptionItems.vue?vue&type=template&id=a7d95ccc&scoped=true"
import script from "./InvoiceReceptionItems.vue?vue&type=script&lang=js"
export * from "./InvoiceReceptionItems.vue?vue&type=script&lang=js"
import style0 from "./InvoiceReceptionItems.vue?vue&type=style&index=0&id=a7d95ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d95ccc",
  null
  
)

export default component.exports